import { type ControllerApiConstructor } from './abstract'
import { AbstractSelfInitSdk } from './abstractSelfInit'
import { Catch } from './catchError'
import { FeatureControllerApi, type FeaturesResponseSuccess } from './generated'

export class FeatureStatesSdk extends AbstractSelfInitSdk<FeatureControllerApi> {
  protected getControllerApiConstructor(): ControllerApiConstructor<FeatureControllerApi> {
    return FeatureControllerApi
  }

  @Catch<FeaturesResponseSuccess>()
  async getFeatureStates(): Promise<FeaturesResponseSuccess> {
    const axiosOptions = this.userSdk.createAxiosOptions()
    const userSdkHeader = this.userSdk.getBffHeader()

    return (await this.api.features(userSdkHeader, axiosOptions)).data
  }
}
